import type { CmsBootstrapRequest } from '#src/interfaces/CmsBootstrapRequest'
import type { CmsAppName, CmsBootstrapByApp, CmsDeviceSettings } from '#src/interfaces/CmsConfig'
import type { CmsTermsAndConditionsResponse } from '#src/interfaces/CmsTermsAndConditions'

import cmsApiInstance from '#src/services/cmsApiClient'

const CMS_BASIC_AUTH_APPS: CmsAppName[] = ['pos', 'ssbt-bo']

const getCmsBasicAuthConfig = (appName: CmsAppName) =>
  CMS_BASIC_AUTH_APPS.includes(appName)
    ? {
        auth: {
          username: import.meta.env.VITE_CMS_BASIC_AUTH_USERNAME,
          password: import.meta.env.VITE_CMS_BASIC_AUTH_PASSWORD
        }
      }
    : undefined

const fetchAppBootstrap = <A extends CmsAppName>(appName: A, request: CmsBootstrapRequest) =>
  cmsApiInstance.post<CmsBootstrapByApp[A]>(
    `${appName}/bootstrap`,
    request,
    getCmsBasicAuthConfig(appName)
  )

const getTermsAndConditions = (appName: string, lang: string) =>
  cmsApiInstance.get<CmsTermsAndConditionsResponse>(`/${appName}/terms-and-conditions?lang=${lang}`)

const saveSsbtBackOfficeSettings = (data: CmsDeviceSettings) =>
  cmsApiInstance.post<CmsDeviceSettings>('ssbt-back-office-settings', data)

export { fetchAppBootstrap, getTermsAndConditions, saveSsbtBackOfficeSettings }
